export const POSITIONS_FETCH_SUCCESS = 'POSITIONS_FETCH_SUCCESS';

export const positionsSuccess = (positions: any) => ({
  type: POSITIONS_FETCH_SUCCESS,
  payload: positions
});